import {
  FETCH_PROTHEUS_STATUS,
  FETCH_PROTHEUS_STATUS_ERROR,
  UPDATE_PROTHEUS_TOKEN,
  UPDATE_PROTHEUS_TOKEN_ERROR,
  REFRESH_PROTHEUS_TOKEN,
  REFRESH_PROTHEUS_TOKEN_ERROR,
  RESET_PROTHEUS_INFO,
} from './types';
import { handleResponseError } from './handleResponseError';

export const fetchProtheusStatus = () => async (dispatch, getState, connections) => {
  const token = sessionStorage.getItem('userToken');
  connections.apiAdmin.defaults.headers['Content-Type'] = 'application/json';
  if (token) {
    connections.apiAdmin.defaults.headers['token'] = token;
  }

  await connections.apiAdmin
    .get('/protheus/status')
    .then((res) => {
      dispatch({
        type: FETCH_PROTHEUS_STATUS,
        payload: res.data,
      });
    })
    .catch((e) => {
      console.error(`action: ${FETCH_PROTHEUS_STATUS}: ${e.message}`);
      dispatch({
        type: FETCH_PROTHEUS_STATUS_ERROR,
        payload: handleResponseError(e, 'Falha ao buscar status do token Protheus'),
      });
    });
};

export const updateProtheusToken = (accessToken, refreshToken) => async (
  dispatch,
  getState,
  connections
) => {
  const token = sessionStorage.getItem('userToken');
  connections.apiAdmin.defaults.headers['Content-Type'] = 'application/json';
  if (token) {
    connections.apiAdmin.defaults.headers['token'] = token;
  }

  await connections.apiAdmin
    .post('/protheus/token', {
      access_token: accessToken,
      refresh_token: refreshToken,
    })
    .then((res) => {
      dispatch({
        type: UPDATE_PROTHEUS_TOKEN,
        payload: res.data,
      });
    })
    .catch((e) => {
      console.error(`action: ${UPDATE_PROTHEUS_TOKEN}: ${e.message}`);
      dispatch({
        type: UPDATE_PROTHEUS_TOKEN_ERROR,
        payload: handleResponseError(e, 'Falha ao salvar os tokens do Protheus'),
      });
    });
};

export const refreshProtheusToken = () => async (
  dispatch,
  getState,
  connections
) => {
  const token = sessionStorage.getItem('userToken');
  connections.apiAdmin.defaults.headers['Content-Type'] = 'application/json';
  if (token) {
    connections.apiAdmin.defaults.headers['token'] = token;
  }

  await connections.apiAdmin
    .post('/protheus/refresh')
    .then((res) => {
      dispatch({
        type: REFRESH_PROTHEUS_TOKEN,
        payload: res.data,
      });
    })
    .catch((e) => {
      console.error(`action: ${REFRESH_PROTHEUS_TOKEN}: ${e.message}`);
      dispatch({
        type: REFRESH_PROTHEUS_TOKEN_ERROR,
        payload: handleResponseError(e, 'Falha ao renovar token junto ao Protheus'),
      });
    });
};

export const resetProtheusInfo = () => ({
  type: RESET_PROTHEUS_INFO,
});
